import axios from "axios";
import {
    type IProductSpecItem,
    apiUrlUpdatedProductListVue,
    mapVueItemToUpdatedRequest,
} from "../..";
import { VueProductSpecMultiUpdater } from "./VueProductSpecMultiUpdater";
import { type CallbackUpdatedItem } from "../../types";

export class VueProductSpecItem implements IProductSpecItem {
    shouldAppendToAuctionSocket: boolean = true;
    auctionSocketId: number;
    itemId: number;
    forced: boolean = false;
    forcedStamp: string = "";
    secondsLeftGetter: () => number;
    callbackUpdatedItem: CallbackUpdatedItem;
    refreshTriggered: boolean = false;
    //contextAuctionId: any;
    constructor({
        productId,
        secondsLeftGetter,
        callbackUpdatedItem,
    }: {
        productId: number;
        //contextAuctionId: number,
        secondsLeftGetter: () => number;
        callbackUpdatedItem: CallbackUpdatedItem;
    }) {
        this.auctionSocketId = productId;
        this.itemId = productId;
        this.secondsLeftGetter = secondsLeftGetter;
        this.callbackUpdatedItem = callbackUpdatedItem;
        //this.contextAuctionId = contextAuctionId;
        this.boundSetMarkForUpdate = this.setMarkForUpdate.bind(this);
    }
    boundSetMarkForUpdate: (
        id: string,
        stampData: string | null | undefined
    ) => void;
    setMarkForUpdate(id: string, stampData: string | null | undefined): void {
        this.forced = true;
        if (stampData != null) this.forcedStamp = atob(stampData);
        else this.forcedStamp = "";
    }
    resetMarkForUpdate() {
        this.forced = false;
        this.forcedStamp = "";
        this.setRefreshTriggered(false);
    }
    getSecondsLeft(): number {
        return this.secondsLeftGetter();
    }
    getRefreshTriggered(): boolean {
        return this.refreshTriggered;
    }
    setRefreshTriggered(value: boolean): void {
        this.refreshTriggered = value;
    }
    async update(context: string): Promise<void> {
        const response = await axios.post(apiUrlUpdatedProductListVue, {
            items: [mapVueItemToUpdatedRequest(this)],
        });
        const item = response.data[0];
        this.callbackUpdatedItem(item, context);
    }

    shouldQueue: boolean = true;
    multiUpdaterType = VueProductSpecMultiUpdater;
}
